import styles from "./Service.module.css";

export const Service = () => {
  return (
    <section
      className={`flat-spacing-1 flat-iconbox wow fadeInUp ${styles.serviceSection}`}
      data-wow-delay="0s"
    >
      <div className="container">
        <div className={`${styles.serviceGrid} wrap-mobile`}>
          <div className="tf-icon-box style-row">
            <div className="icon">
              <i className="icon-shipping"></i>
            </div>
            <div className="content">
              <div className="title fw-4">Free Delivery</div>
              <p>Within 2 km</p>
            </div>
          </div>

          <div className="tf-icon-box style-row">
            <div className="icon">
              <i className="icon-payment fs-22"></i>
            </div>
            <div className="content">
              <div className="title fw-4">Flexible Payment</div>
              <p>Pay with Multiple Credit Cards</p>
            </div>
          </div>

          <div className="tf-icon-box style-row">
            <div className="icon">
              <i className="icon-return fs-20"></i>
            </div>
            <div className="content">
              <div className="title fw-4">Order on the Go</div>
              <p>Our App Coming Soon</p>
            </div>
          </div>

          <div className="tf-icon-box style-row">
            <div className="icon">
              <i className="icon-suport"></i>
            </div>
            <div className="content">
              <div className="title fw-4">Available for You</div>
              <p>Online Support 24/7</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
